import { httpGet, urlConcat, httpPost } from '@/utils/http'
import { API_TENDER } from '@/config'

export async function sendEmailForRecovery(data) {
  const url = urlConcat(API_TENDER, '/recovery/Forgot');
  return await httpPost(url, data, {withCredentials: true});
}

export async function changePassword(data) {
  const url = urlConcat(API_TENDER, '/recovery/ChangePassword');
  return await httpPost(url, data, {withCredentials: true});
}